// Shared image-search helpers used by the project Images page (ListImages) and the
// viewer's Images drawer (ImageSelector), so both build the same server-side
// `filterExpression` over the image name + indexed case-info columns.

// Fields the quick-search box ORs across (server-side via filterExpression), beyond
// the filename. Substring matched (ILIKE '%x%') — kept index-backed by the pg_trgm
// GIN indexes (see 2026-06-12-image-search-trigram-indexes.sql).
export const SEARCH_FIELDS = [
  'name',
  'caseId',
  'patientFullName',
  'clinicName',
  'doctorReferringName',
  'specimenId',
  'slideId',
  'slideBlockId',
  'slideExternalId'
];

// Build the images-list filterExpression (array of {field, operator, value, conj}).
//  - search:        the quick-search string (OR'd across SEARCH_FIELDS)
//  - builderFilters: rows from the Filters builder ({column, operator, value, conj})
//  - inlineColumns / inlineFilters: per-column inline filters (images page only)
export function buildImageFilterExpression({search = '', builderFilters = [], inlineColumns = [], inlineFilters = {}} = {}) {
  const expr = [];

  const q = (search || '').trim();
  if (q) {
    SEARCH_FIELDS.forEach((f, i) => {
      expr.push({field: f, operator: 'contains', value: q, conj: i === 0 ? 'and' : 'or'});
    });
  }

  for (const col of inlineColumns) {
    if (!col.filterable) {
      continue;
    }
    const v = inlineFilters[col.key];
    if (v === undefined || v === null || v === '') {
      continue;
    }
    const op = (col.type === 'number' || col.type === 'date') ? 'is' : 'contains';
    expr.push({field: col.key, operator: op, value: v, conj: 'and'});
  }

  let firstBuilder = true;
  builderFilters.forEach(f => {
    if (f.operator !== 'is-empty' && (f.value === '' || f.value === null || f.value === undefined)) {
      return;
    }
    const conj = (expr.length === 0 || firstBuilder) ? 'and' : f.conj;
    expr.push({field: f.column, operator: f.operator, value: f.value, conj});
    firstBuilder = false;
  });

  return expr;
}
